jQuery(function ($) {
	// My Support Tab
	$(".nav-tab .icon-block-container").each(function () {
		$(this).on("click", function () {
			// console.log($(this).children()[0].hasClass("active"));
			if (!$(this).find(".icon-block").hasClass("active")) {
				$(this).find(".icon-block").addClass("active white-shadow");
				// $(this).removeClass("drop-shadow");
				$(this).siblings().find(".icon-block").removeClass("active");
				$(this)
					.siblings()
					.find(".icon-block")
					.removeClass("white-shadow")
					.addClass("drop-shadow");

				// text color
				// $(this).children().find("h2.small-heading").removeClass("grey");
				// $(this).siblings().children().find("h2.small-heading").addClass("grey");
			}
		});
	});

	// Channel Line up | Themes packs
	$("#channel-lineup .shuffle-section .shuffle-menu-container li").on(
		"click",
		function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("shuffle-menu-active");
				$(this).siblings().removeClass("shuffle-menu-active");

				// Channel line up -> hide search bar and download guide when clicked on theme packs
				if ($(this).children().text() == "Theme Packs") {
					$("#channel-lineup .channel-search-input").css(
						"visibility",
						"hidden"
					);
					$("#channel-lineup .download-guide").css("visibility", "hidden");
				} else {
					$("#channel-lineup .channel-search-input").css(
						"visibility",
						"visible"
					);
					$("#channel-lineup .download-guide").css("visibility", "visible");
				}
			}
		}
	);

	// Accessibility Main Tab
	// var icons_names = [
	//   "about-hearing-blue",
	//   "about-visual-blue",
	//   "about-mobility-blue",
	//   "about-cognitive-blue",
	// ];
	$("#pills-tabContent .swiper-slide .tab-block").each(function () {
		$(this).on("click", function () {
			// console.log(color);
			// var current_img_src;

			// current_img_src = $(this).children()[0].attributes[0].nodeValue;

			$tabid = $(this).attr("data-tabid");
			// console.log($tabid);
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this).removeClass("drop-shadow");
				$(this).parent().siblings().children().removeClass("active");
				$(this)
					.parent()
					.siblings()
					.children()
					.removeClass("white-shadow")
					.addClass("drop-shadow");

				// $(
				//   "#pills-tabContent .swiper-slide .active .tab-icon-block-switch img"
				// ).each(function () {
				//   if (
				//     $(
				//       "#pills-tabContent .swiper-slide .active .tab-icon-block-switch .img-icon-color"
				//     ).hasClass("d-none")
				//   ) {
				//     $(
				//       "#pills-tabContent .swiper-slide .active .tab-icon-block-switch .img-icon-color"
				//     ).removeClass("d-none");
				//     $(
				//       "#pills-tabContent .swiper-slide .active .tab-icon-block-switch .icon-image"
				//     ).addClass("d-none");
				//   }
				// });
			}
			// -------------------------------

			$("#pills-tabContent-access .tab-pane").each(function () {
				if ($(this).attr("id") == $tabid) {
					if (!$(this).hasClass("active")) {
						$(this).addClass("show active");
						$(this).siblings().removeClass("show active");
					}
				}
			});
		});
	});

	// Sub Tab Accessibility Vertical Tabs and pills
	$("#pills-tabContent-access .tab-pane .service-title a").each(function () {
		$(this).on("click", function () {
			$subtab = $(this).attr("data-target");
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this).parent().siblings().children().removeClass("active");
			}

			$("#tab-sub-content .tab-pane").each(function () {
				if ($(this).attr("id") == $subtab) {
					if (!$(this).hasClass("active")) {
						$(this).addClass("show active");
						$(this).siblings().removeClass("show active");
					}
				}
			});
		});
	});

	// Tab -> Mobile Rate Plans
	// Main Two Tabs
	$("#mobile-rate-plans .shuffle-menu-container li").on("click", function () {
		if (!$(this).hasClass("active")) {
			$(this).addClass("shuffle-menu-active");
			$(this).siblings().removeClass("shuffle-menu-active");
		}
	});

	$("#choose-plan .main-tab-container li").on("click", function () {
		if (!$(this).hasClass("active")) {
			$(this).addClass("shuffle-menu-active");
			$(this).siblings().removeClass("shuffle-menu-active");
		}
	});

	// Tabs Block
	// Give 'show active' class to the first tab of .block-tabs .tab-pane
	$(".block-tabs .tab-pane").first().addClass("show active");
});
